import { ClipLoader } from 'react-spinners';
import { differenceInMinutes } from 'date-fns';
import {
  ContactContainer,
  CouponContainer,
  LoadingPaymentMenthods,
  PaymentInBatchesContainer,
  PaymentInBatchesPage,
  PaymentMethodContainer,
} from './components/styled';
import { useCallback, useEffect, useState } from 'react';
import AsyncLoadingTable from './components/AsyncLoadingTable';
import PaymentMethods from './components/PaymentMethods';

import {
  FaCheckCircle,
  FaChevronDown,
  FaChevronUp,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
} from 'react-icons/fa';
import { RiErrorWarningFill, RiInstagramFill } from 'react-icons/ri';
import { IoLogoWhatsapp } from 'react-icons/io';
import { FaCircleChevronLeft, FaCircleChevronRight } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { StyledInput } from '../../components/StyledInput';
import { BsXCircleFill } from 'react-icons/bs';
import { IDebtsByUf, InstallmentInfo, usePayment } from '../../context/PaymentContext';
import debounce from 'lodash.debounce';
import GenericModal from '../../components/GenericModal';
import { FiChevronRight, FiX } from 'react-icons/fi';
import theme from '../../styles/themes/default';
import Swal from 'sweetalert2';
import { findConsultById } from '../../hooks/usePayments';
import Modal from 'react-modal';
import { PiWarningCircleBold } from "react-icons/pi";

export default function PaymentInBatches() {
  const {
    availableCoupon,
    cupomStatus,
    debtsForTable,
    installmentsLoading,
    allDebtsSelected,
    selectedDebts,
    installments,
    handleSetCupom,
    pix,
    isPix,
    debtsTotal,
    entryMessage,
    exitMessage,
    consultCode,
    handleConsultClean
  } = usePayment();

  const [order, setOrder] = useState<'desc' | 'asc'>('desc');
  const [orderBy, setOrderBy] = useState<string>('updated_at');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showCoupon, setShowCoupon] = useState<boolean>(true);
  const [cupom, setCupom] = useState<string | undefined>(undefined);
  const [zignetFee, seZignetFee] = useState<number>(0);
  const [entryMessageModal, setEntryMessageModal] = useState(false);
  const [exitMessageModal, setExitMessageModal] = useState(false);
  const [exitMessageComponent, setExitMessage] = useState('');
  const [showModalConfirmedPix, setShowModalConfirmedPix] = useState(false);

  const [installmentSelected, setInstallmentSelected] = useState<
    InstallmentInfo | undefined
  >(undefined);

  const navigate = useNavigate();

  const headers = [
    { key: 'uf', label: 'UF' },
    { key: 'vehicle.placa', label: 'Placa' },
    { key: 'driver.name', label: 'IPVA' },
    { key: 'vehicle.licensingStatus', label: 'Licenciamento' },
    { key: 'fullTotalDebts', label: 'Multas' },
    { key: 'updated_at', label: 'DPVAT' },
    { key: 'updated_at', label: 'Outros' },
    { key: 'updated_at', label: 'Total' },
  ];

  useEffect(() => {
    setIsLoading(installmentsLoading);
  }, [installmentsLoading]);

  useEffect(() => {
    if (isPix) {
      setInstallmentSelected(pix);
    } else {
      const selected = installments.filter(
        (installment) => installment.checked,
      );
      setInstallmentSelected(
        selected && selected.length > 0 ? selected[0] : ({} as InstallmentInfo),
      );
    }
  }, [installments, pix]);

  useEffect(() => {
    if (!installmentsLoading) {
      if (!pix && (!installments || installments?.length === 0)) {
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Falha ao carregar débitos!',
        //   html: `Ocorreu um erro inesperado ao carregar os débitos.`,
        //   confirmButtonColor: theme.colors.orange.primary,
        //   didClose: () => {
        //     navigate("/debts")
        //   }
        // });
      }
    }
  }, [installments, pix, isLoading])

  useEffect(() => {
    const installment = installments.find((i) => i.checked === true);
    if (installment) {
      const zignetFee =
        Number(installment?.totalPrice) -
        debtsTotal ?? 0;
      seZignetFee(zignetFee);
    } else {
      const zignetFee =
        Number(pix?.totalPrice) -
        debtsTotal ?? 0;
      seZignetFee(zignetFee);
    }
  }, [
    installments,
    debtsTotal,
    pix,
    zignetFee,
  ]);

  function handleMoneyValues(value: string | number) {
    return `R$ ${(value || 0)?.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  const debouncedSave = useCallback(
    debounce((nextValue: any) => handleSetCupom(nextValue), 1000),
    []
  )

  const handleCupomInput = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const regex = /[⁰¹²³⁴⁵⁶⁷⁸⁹ºª]/g;
      const value = e.currentTarget.value.replace(regex, '');

      setCupom(value);

      if (value.length === 0 || value.length > 4) {
        debouncedSave(value);
      }
    },
    [debouncedSave]
  );

  useEffect(() => {
    setEntryMessageModal(!!entryMessage);
  }, [entryMessage])

  useEffect(() => {
    setExitMessage(exitMessage)
  }, [exitMessage])

  const handleClickEntryMessageModal = useCallback(() => {
    setEntryMessageModal(false);
    if (availableCoupon) {
      setCupom(availableCoupon);
      handleSetCupom(availableCoupon);
    }
  }, [availableCoupon]);

  const handleClickExitMessageModal = useCallback(() => {
    setExitMessageModal(false);
    setIsLoading(true);
    navigate('/debts/pix');
  }, []);

  const handlePayNowButton = useCallback(async () => {
    if (debtsTotal === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Aviso!',
        html: 'Nenhum débito selecionado',
        confirmButtonColor: theme.colors.orange.primary,
      });
      return;
    }

    if (!cupomStatus) {
      setCupom('');
      handleSetCupom('');
    }


    if (!consultCode) {
      Swal.fire({
        icon: 'error',
        title: 'Falha ao carregar a consulta!',
        html: `Ocorreu um erro inesperado ao carregar os dados da consulta.`,
        confirmButtonColor: theme.colors.orange.primary,
        didClose: () => {
          handleConsultClean()
          navigate("/debts")
        }
      });
      return
    }

    setIsLoading(true);
    const storageConsult = await findConsultById(consultCode ?? 0);
    console.log('storageConsult', storageConsult);


    if (storageConsult.payloadCaptura) {
      setIsLoading(false);
      window.localStorage.setItem(
        'zignet:ConsultInProgress',
        JSON.stringify(storageConsult),
      );
      window.localStorage.setItem(
        'zignet:PayloadCaptura',
        JSON.stringify(storageConsult.payloadCaptura),
      );
      window.localStorage.setItem(
        'zignet:PayloadComprovante',
        JSON.stringify(storageConsult.payloadComprovante),
      );
      window.localStorage.setItem(
        'zignet:PayloadConsulta',
        JSON.stringify(storageConsult.payloadConsulta),
      );
      Swal.fire({
        icon: 'warning',
        html: `Já existe um pagamento em andamento para este veículo;`,
        confirmButtonColor: theme.colors.orange.primary,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/proof');
        }
      });
      return;
    }

    const checkConsultDuration =
      differenceInMinutes(new Date(), new Date(storageConsult?.created_at)) -
      180;
    console.log("🚀 ~ handlePayNowButton ~ checkConsultDuration:", checkConsultDuration)

    setIsLoading(false);

    // if (checkConsultDuration >= 30) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'Aviso!',
    //     html: 'Tempo de operação expirado. Por favor realize uma nova consulta para efetuar o pagamento',
    //     confirmButtonColor: theme.colors.orange.primary,
    //   });
    //   return;
    // }

    // if (exitMessageComponent !== '') {
    //   setExitMessageModal(true);
    //   return;
    // }

    // if (!isLoggedIn) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'Aviso!',
    //     html: 'Tempo de operação expirado. Por favor realize uma nova consulta para efetuar o pagamento',
    //     confirmButtonColor: theme.colors.orange.primary,
    //   });
    // } else {
    // console.log("Entrou aqui2")
    // setIsLoading(true);
    if (pix?.checked) {
      navigate('/debts/pix');
    } else {
      navigate('/debts/credit-payment');
    }
    // }
  }, [
    debtsTotal,
    cupomStatus,
    consultCode,
    cupom,
    exitMessageComponent,
    handleSetCupom,
    pix,
  ]);

  function sumAllDebtsByUf(debts: any[]) {

    const value = debts.reduce((acc, debt) => {
      return acc + debt.total
    }, 0)

    return `R$ ${(value ?? 0)?.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
  }

  return (
    <PaymentInBatchesPage>
      <GenericModal open={exitMessageModal} setOpen={setExitMessageModal}>
        <span style={{
          display: 'flex',
          width: '100%',
          textAlign: 'center',
          fontSize: '32px',
          justifyContent: 'center',
          marginBottom: '10px',
          color: '#f58220'
        }}>
          <PiWarningCircleBold />
        </span>
        <div
          className={'entryMessageModal'}
          dangerouslySetInnerHTML={{
            __html: exitMessage
          }}
        ></div>
        <div className="entryMessageModalButton">
          <button type="button" onClick={handleClickExitMessageModal}>
            {"Continuar"}
            <FiChevronRight />
          </button>
        </div>
      </GenericModal>
      <GenericModal open={entryMessageModal} setOpen={setEntryMessageModal}>
        <span style={{
          display: 'flex',
          width: '100%',
          textAlign: 'center',
          fontSize: '32px',
          justifyContent: 'center',
          marginBottom: '10px',
          color: '#f58220'
        }}>
          {!availableCoupon && <PiWarningCircleBold />}
        </span>
        <div
          className={'entryMessageModal'}
          dangerouslySetInnerHTML={{
            __html: entryMessage,
          }}
        ></div>
        <div className="entryMessageModalButton">
          <button type="button" onClick={handleClickEntryMessageModal}>
            {availableCoupon ? 'Aplicar cupom' : 'Continuar'}
            <FiChevronRight />
          </button>
        </div>
      </GenericModal>

      <Modal
        isOpen={showModalConfirmedPix}
        onRequestClose={() => setShowModalConfirmedPix(false)}
        className={'modalConfirmedPix'}
        style={{
          overlay: { zIndex: 1001 },
          content: {},
        }}
      >
        <div className={'iconWarning'}>
          <RiErrorWarningFill size="44" />
        </div>
        <div
          className={'txtPoliticaPrivacidade'}
          id="warning-message"
          style={{
            textAlign: 'center',
          }}
        >
          Você está finalizando o pagamento de débitos da seguinte frota:
          {debtsForTable.map(debt => {

            return (<p
              style={{
                textAlign: 'center',
                marginTop: '5px'
              }}
            >
              {`${debt.uf} - `}
              <span
                style={{
                  fontWeight: 600,
                }}
              >
                {sumAllDebtsByUf(debt.data)}
              </span>
            </p>)
          })}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            width: '100%',
          }}
        >
          <div className={'modalButton'}>
            <button
              onClick={() => {
                setShowModalConfirmedPix(false);
              }}
            >
              Fechar
              <FiX />
            </button>
          </div>
          <div className={'modalButton'}>
            <button
              onClick={() => {
                setShowModalConfirmedPix(false);
                handlePayNowButton();
              }}
            >
              Pagar
              <FiChevronRight />
            </button>
          </div>
        </div>
      </Modal>

      <PaymentInBatchesContainer>
        <div className="container">
          <h1 className="page-title">Pagamento em lote</h1>

          <div className="loading-text">
            {isLoading && <ClipLoader size={25} color="#B4B4B4" />}
            {isLoading ? (
              <span>Carregando todos os débitos </span>
            ) : (
              <span>Débitos carregados</span>
            )}
            {isLoading ? (
              <strong>{`(${selectedDebts.length ?? 0} de ${allDebtsSelected?.length ?? 0}  carregados)`}</strong>
            ) : (
              <strong>{`(${allDebtsSelected?.length ?? 0} débitos)`}</strong>
            )}
          </div>

          <AsyncLoadingTable
            title="Listagem de Débitos"
            error={''}
            heads={headers}
            order={order}
            setOrder={setOrder}
            data={debtsForTable}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            isLoading={isLoading}
          />
        </div>

        <div className="debts-table-list">
          <div className="contact-and-ticket">
            <ContactContainer>
              <h3>DÚVIDAS? FALE CONOSCO!</h3>

              <div className="content">
                <div className="hour-address">
                  <div className="item">
                    <strong>Horário de Funcionamento</strong>
                    <span>Seg. a Sex. - 08hs às 19hs</span>
                  </div>
                  <div className="item">
                    <strong>Capital de SP e Regiões</strong>
                    <span>11 5171-8484</span>
                  </div>
                  <div className="item">
                    <strong>Demais Localidades</strong>
                    <span>0800 5800 094</span>
                  </div>
                </div>
                <div className="contacts">
                  <div className="item">
                    <strong>WhatsApp</strong>
                    <span>11 94549-1306</span>
                  </div>
                  <div className="item">
                    <strong>E-mail</strong>
                    <span>atendimento@zignet.com.br</span>
                  </div>
                  <div className="item icons">
                    <a
                      href="https://web.facebook.com/zignetbrasil"
                      target="_blank"
                    >
                      <FaFacebook />
                    </a>
                    <a
                      href="https://www.instagram.com/Zignet_oficial/"
                      target="_blank"
                    >
                      <RiInstagramFill />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/zignet/"
                      target="_blank"
                    >
                      <FaLinkedin />
                    </a>
                    <a
                      href="https://api.whatsapp.com/send?phone=5511945491306&text=Ol%C3%A1,%20Zignet"
                      target="_blank"
                    >
                      <IoLogoWhatsapp />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UC07YZyHWRKS2xIbFptaT8Bg "
                      target="_blank"
                    >
                      <FaYoutube />
                    </a>
                  </div>
                </div>
              </div>
            </ContactContainer>
            <CouponContainer valid={cupomStatus} open={showCoupon}>
              <div className="coupon-container">
                <div className="header-togg">
                  <div
                    className="main-togg"
                    onClick={() => setShowCoupon(!showCoupon)}
                  >
                    <span> Inserir Cupom de Desconto </span>
                    {!showCoupon ? <FaChevronDown /> : <FaChevronUp />}
                  </div>
                  {availableCoupon && <div className='available-status' onClick={() =>
                    setEntryMessageModal(!entryMessageModal)
                  }>
                    <FaCheckCircle />
                    <span>Cupom disponível</span>
                  </div>
                  }
                </div>
                <div
                  className={`content ${cupomStatus === undefined ? 'neutral' : ''
                    }`}
                >
                  {showCoupon && (
                    <div className="ticket-input">
                      <StyledInput
                        placeholder="Insira seu cupom de desconto"
                        value={cupom}
                        onChange={handleCupomInput}
                        icon={
                          cupom !== undefined && cupom.length > 0 ? (
                            cupomStatus ? (
                              <FaCheckCircle />
                            ) : (
                              <BsXCircleFill />
                            )
                          ) : undefined
                        }
                      />
                    </div>
                  )}
                  <div className="descount-values">
                    {!!installmentSelected?.discount &&
                      installmentSelected.discount > 0 && (
                        <div className="descount">
                          <span>Desconto aplicado</span>
                          <span>
                            {' '}
                            -{handleMoneyValues(installmentSelected?.discount)}
                          </span>
                        </div>
                      )}
                    <div className="values">
                      <strong>Total Selecionado</strong>
                      <strong>{isLoading ? "Carregando..." : handleMoneyValues(zignetFee + debtsTotal)}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div className="actions">
                <div className="new-consult" onClick={() => {
                  handleConsultClean()
                  navigate('/debts')
                }}>
                  <FaCircleChevronLeft />
                  <span>Nova Consulta</span>
                </div>
                <div
                  className="submit-btn"
                  onClick={() => {
                    if (pix?.checked) {
                      setShowModalConfirmedPix(true)
                    } else {
                      handlePayNowButton()
                    }
                  }}
                >
                  <span>Pagar Agora</span>
                  <FaCircleChevronRight />
                </div>
              </div>
            </CouponContainer>
          </div>
        </div>
      </PaymentInBatchesContainer>

      <PaymentMethodContainer>
        <h1 className="page-title method-title">Métodos de pagamento</h1>
        <div className="payment-methods">
          {!isLoading ? (
            <PaymentMethods />
          ) : (
            <LoadingPaymentMenthods>
              <div className="content">
                <ClipLoader color={'#F58220'} size={45} />
                <p>
                  Os métodos de pagamento aparcerão aqui após todos os débitos
                  serem carregados.
                  <br />
                  Por favor, aguarde...
                </p>
              </div>
            </LoadingPaymentMenthods>
          )}
        </div>
      </PaymentMethodContainer>
    </PaymentInBatchesPage>
  );
}
